import olMap from 'ol/Map';
import VectorSource from "ol/source/Vector";
import VectorLayer from 'ol/layer/Vector';
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import GeoJSON from 'ol/format/GeoJSON';
import * as olLoadingstrategy from 'ol/loadingstrategy';
import WKT from 'ol/format/WKT';
import Projection from "ol/proj/Projection";
import { Extent } from 'ol/extent';
import { bbox, equalTo, or, and } from 'ol/format/filter';
import Filter from "ol/format/filter/Filter";
import WFS from 'ol/format/WFS';
import { Feature } from 'ol';




export class MapHighlightFeatures {

    private _highlightOverlay: VectorLayer;
    private _parser: GeoJSON;
    private _legacyrouteids: Array<number> = [];
    private _routeids: Array<number | string> = [];
    private _landregistryids: Array<Feature> = [];
    private _prowcodes: Array<number> = [];


    public constructor(private _theMap: olMap, private _WfsUrl: string) {
        let self = this;
        let vectorSource = new VectorSource({
            format: new GeoJSON(),
            loader: function (extent, resolution, projection) {
                self.loader(extent, resolution, projection);
            },
            strategy: olLoadingstrategy.bbox
        });

        this._highlightOverlay = new VectorLayer({
            style: new Style({
                stroke: new Stroke({
                    color: 'rgba(26, 255, 22, 1.0)',
                    width: 4
                })
            }),
            source: vectorSource,
            map: this._theMap
        });
    }

    private loader = (
        extent: Extent,
        resolution: number,
        displayProjection: Projection): void =>
    {
        this._highlightOverlay.getSource().clear(true);

        if (this._landregistryids.length > 0) {
            //loadFeatures("LandRegistry", getFilterString(landregistryids, "gml_id", "LandRegistry"));

            this._landregistryids.forEach(parcel => {
                let wktFormat = new WKT();
                let feature = wktFormat.readFeature(parcel["wkt"], {
                    dataProjection: "EPSG:27700",
                    featureProjection: "EPSG:3857"
                })
                this._highlightOverlay.getSource().addFeature(feature);
            });
        }

        if (this._routeids.length > 0) {
            this.loadFeatures("HighlightRoutes", this.getFilterString(this._routeids, "RouteGUID", "HighlightRoutes"));
        }

        if (this._legacyrouteids.length > 0) {
            this.loadFeatures("HighlightLegacyRoutes", this.getFilterString(this._legacyrouteids, "LegacyRouteID", "HighlightLegacyRoutes"));
        }

        if (this._prowcodes.length > 0) {
            this.loadFeatures("PROW-Byway", this.getFilterString(this._prowcodes, "PROW_Code", "PROW-Byway"));
        }
    }

    private loadFeatures = (typename: string, filterString: string): void => {
        let self = this;
        let url: string = `${this._WfsUrl}?VERSION=2.0.0&outputFormat=geojson&SERVICE=WFS&REQUEST=GetFeature&SRSNAME=EPSG:3857&TYPENAME=${typename}&Filter=${filterString}`;

        $.ajax({
            url: url,
            method: "GET"
        })
        .done(function (response) {
            self._parser = new GeoJSON();
            let features = self._parser.readFeatures(response);
            self._highlightOverlay.getSource().addFeatures(features);
        });
    }


    private getFilterString = (ids: Array<number | string>, paramname: string, typename: string): string => {
        let filters: Filter;

        if (ids.length === 1) {
            filters = equalTo(paramname, ids[0]);

        } else if (ids.length > 1) {
            let t1 = [];
            for (let i = 0; i < ids.length; i++) {
                t1.push(equalTo(paramname, ids[i] + " "));
            }
            filters = or.apply(this, t1);
        }

        let featureRequest: Node = new WFS().writeGetFeature({
            srsName: 'EPSG:3857',
            featureNS: '',
            featurePrefix: '',
            featureTypes: [typename],
            outputFormat: 'geojson',
            filter: filters
        });

        let filterStr: string = new XMLSerializer().serializeToString(featureRequest.firstChild.firstChild);

        return encodeURIComponent(filterStr.replace(' xmlns="http://www.opengis.net/ogc"', ""));
    }

    public clear = () : void => {
        this._routeids = [];
        this._legacyrouteids = [];
        this._landregistryids = [];
        this._prowcodes = [];
        this._highlightOverlay.getSource().clear(true);
    }

    public highlightFeaturesAtEvent = (
        evt,
        rids: Array<number | string>,
        legacyrids: Array<number>,
        landregistrylabels: Array<Feature>): void =>
    {
        this._routeids = rids;
        this._legacyrouteids = legacyrids;
        this._landregistryids = landregistrylabels;       
        this._highlightOverlay.getSource().refresh();                
    }

}